














import { makeImgixUrl } from '@bkwld/cloak/services/helpers'

export default

	props: card: Object

	computed:
		image: -> @card.pressKitAsset?[0]
		mimeType: -> @card.pressKitAsset?[0]?.mimeType
		url: -> makeImgixUrl @image?.path
		fillType: ->
			if @mimeType == 'image/png' then return 'contain'
			else return 'cover'

